import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestOptions, Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import {Observable} from "rxjs/Observable";
import { environment } from './../../environments/environment'
import { Dependent } from '../_models/dependent.model';

@Injectable()
export class DependentService {

  private _baseUrl = "";

  constructor(private http: Http, private router: Router ) { 
    this._baseUrl = environment.apiBaseUrl;
  }


  getRelationshipCode(): Observable<any>{
    return this.http.get(this._baseUrl + 'api/dependent/get-relationshipCode')
    .map((res : Response)=>{
      return res.json();
    })
  }

  updateDependent(dependent): Observable<any>{
    return this.http.put(this._baseUrl + 'api/dependent/update-dependent/' +  dependent.dependentId,dependent)
    .map((res: Response)=>{
      return res.json();
    })
  }


  createNewDependent(dependent, productId: string): Observable<any>{
    return this.http.post(this._baseUrl + `api/dependent/create-new-dependent/${productId}`,dependent)
    .map((res: Response)=>{
      return res.json();
    })
  }

  deleteDependent(dependentId): Observable<any>{
    return this.http.delete(this._baseUrl + 'api/dependent/delete-dependent/' + dependentId)
    .map((res: Response)=>{
      return res.json();
    })
  }

  getDependents(memberId): Observable<any>{
    return this.http.get(this._baseUrl + 'api/dependent/get-dependents/' + memberId)
    .map((res: Response)=>{
      return res.json();
    })
  }

  getParentMemberNotifiedOver18(memberId){
    return this.http.get(this._baseUrl + `/api/dependent/get-parent-notified/${memberId}`)
    .map((response: Response)=>{
        return response.json()
    })
  }

  getDependentVerified(verificationId){
    return this.http.get(this._baseUrl + `/api/dependent/get-dependent-verified/${verificationId}`)
    .map((response: Response)=>{
        return response.json()
    })
  }

  verifyAndCreatePassword(verificationId, data){
    return this.http.post(this._baseUrl + `/api/dependent/verify-create-password/${verificationId}`,data)
    .map((response: Response)=>{
        return response.json()
    })
  }

  checkEmailExist(dependent){
    return this.http.post(this._baseUrl + `/api/dependent/check-email-existing`, dependent)
    .map((response : Response)=>{
      return response.json();
    })
  }

  getDependentById(dependentId: string){
    return this.http.get(this._baseUrl + `/api/dependent/get-dependent-by-id/${dependentId}`)
    .map((res : Response)=>{
      return res.json();
    })
  }

  updatePassowrd(dependent : Dependent){
    return this.http.put(this._baseUrl + `/api/dependent/change-password`,dependent)
    .map((res: Response)=>{
      return res.json();
    })
  }

  dependentSSOLogin(dependentId:string, productId:string){
    var payloadEndpoint = environment.payloadEndpoint;
    return this.http.post(this._baseUrl + `/api/dependent/dependent-sso-login/${dependentId}/${productId}`,{payloadEndpoint})
    .map((res:Response)=>{
      return res.json();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/dependent.service.ts